var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.996 511.996",
    style: {
      enableBackground: "new 0 0 511.996 511.996"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M256.032,511.964c-65.578,0-131.156-24.962-181.079-74.885c-6.378-6.378-6.38-16.72,0-23.099 c6.378-6.378,16.72-6.38,23.1,0c87.11,87.11,228.851,87.11,315.963,0c87.11-87.11,87.11-228.851,0-315.963 c-87.11-87.11-228.851-87.11-315.961,0c-56.361,56.361-78.483,139.241-57.733,216.299c2.345,8.711-2.814,17.673-11.525,20.018 c-8.707,2.345-17.673-2.814-20.018-11.525c-23.783-88.306,1.575-183.292,66.173-247.891c99.849-99.849,262.313-99.847,362.16,0 c99.847,99.849,99.847,262.313,0,362.16C387.187,487.001,321.61,511.964,256.032,511.964z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffa00038"
    },
    cx: 256.039,
    cy: 256.006,
    r: 154.595
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "M256.032,426.918c-94.246,0-170.921-76.675-170.921-170.92S161.786,85.076,256.032,85.076 s170.921,76.675,170.921,170.921S350.277,426.918,256.032,426.918z M256.032,117.743c-76.234,0-138.255,62.021-138.255,138.255 s62.021,138.255,138.255,138.255s138.255-62.021,138.255-138.255S332.266,117.743,256.032,117.743z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseCircle);
export default __webpack_public_path__ + "static/media/pulse-circle.777dd4cdd0485fd8115d5477509b33a5.svg";
export { ForwardRef as ReactComponent };